import i18next from "@/i18n";
import type { Maybe, MoneyV2, Image as StorefrontImage } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import CompareAtPrice from "@atoms/CompareAtPrice";
import Image from "@atoms/Image";

const translationReturnReason = {
  UNWANTED: i18next.t("account.order.unwanted"),
  DEFECTIVE: i18next.t("account.order.defective"),
};

interface IProps {
  handle: string;
  image:
    | Maybe<StorefrontImage>
    | {
        url: string;
        width: number;
        height: number;
      }
    | null;
  title: string;
  vendor: string;
  size: string;
  quantity: number;
  originalTotalPrice: string;
  discountedTotalPrice: string;
  compareAtPrice: string;
  tags: string[] | null;
  returnReason?: string;
}

// TODO: 주문상세페이지에서 할인정보 가져올 수 없음 -> DraftOrder로 리팩토링 후 수정
function OrderLineItem({
  handle,
  image,
  title,
  vendor,
  size,
  quantity,
  originalTotalPrice,
  discountedTotalPrice,
  compareAtPrice,
  tags,
  returnReason,
}: IProps) {
  const { t } = useTranslation();

  // TODO: Draw 상품이 일반 상품으로 전환되는 경우는 어떻게 처리할지?
  const isDraw = tags?.includes("Draw");

  return (
    <li className="flex gap-2.5 pc:gap-5">
      <div className="flex w-2/3 gap-2.5 pc:gap-5">
        {isDraw ? (
          <Image alt={title} className="w-20! pc:w-32!" src={image?.url ?? ""} />
        ) : (
          <Link to={`/products/${handle}`}>
            <Image alt={title} className="w-20! pc:w-32!" src={image?.url ?? ""} />
          </Link>
        )}
        <div className="flex flex-col gap-1">
          <span>{`${(vendor ?? "").toUpperCase()} ${title}`}</span>
          <span>
            Size {size} × {quantity}
            {t("account.order.count")}
          </span>
          {returnReason ? (
            <span>
              {t("account.return.reason")}:
              {translationReturnReason[returnReason as keyof typeof translationReturnReason]}
            </span>
          ) : null}
        </div>
      </div>
      <div className="flex w-1/3 flex-col gap-1">
        {/* TODO: 구매당시 compareAtprice와 price 보여져야하는지? */}
        <CompareAtPrice
          className="flex flex-col items-end"
          originalPrice={compareAtPrice ? parseInt(compareAtPrice) * quantity : parseInt(originalTotalPrice) * quantity}
          salePrice={parseInt(discountedTotalPrice) * quantity}
        />

        {/*  TODO: 할인 정보 가져올 수 없음 */}
        {/* 상품 할인 */}
        {/* 멤버십 할인 */}
        {/* 할인코드 할인 */}
      </div>
    </li>
  );
}

export default OrderLineItem;
